'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('../typography/ErrorText/ErrorText.js');
require('../typography/LargeDarkText/LargeDarkText.js');
require('../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../typography/MediumDarkText/MediumDarkText.js');
require('../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../typography/MediumText/MediumText.js');
require('../typography/MediumWhiteText/MediumWhiteText.js');
require('../typography/MiniatureLinkText/MiniatureLinkText.js');
var SmallDarkText = require('../typography/SmallDarkText/SmallDarkText.js');
require('../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../typography/SmallDisabledText/SmallDisabledText.js');
require('../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../typography/SmallLinkText/SmallLinkText.js');
require('../typography/SmallTitleText/SmallTitleText.js');
require('../typography/SmallWhiteText/SmallWhiteText.js');
require('../typography/TinyDarkText/TinyDarkText.js');
require('../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../typography/TinyLinkText/TinyLinkText.js');
require('../typography/TinyTitleText/TinyTitleText.js');
require('../typography/XXLargeDarkText/XXLargeDarkText.js');

var Prefix = styled__default.p(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  white-space: pre-wrap;\n  margin: 0;\n  background-color: transparent;\n  font-weight: 600;\n"], ["\n  white-space: pre-wrap;\n  margin: 0;\n  background-color: transparent;\n  font-weight: 600;\n"])));
var Detail = styled__default(SmallDarkText)(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var styledComponents = {
    Detail: Detail,
    Prefix: Prefix,
};
var templateObject_1, templateObject_2;

module.exports = styledComponents;
